import React from 'react';

import { ButtonGroup } from '@atlaskit/button';
import Button, { LinkButton } from '@atlaskit/button/new';
import Modal, {
  ModalTitle,
  ModalBody,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import { Box, Stack, Text } from '@atlaskit/primitives';

import { useIntl } from 'src/hooks/intl';

import { messages } from '../../gpg-keys.i18n';
import { urls } from '../../urls';
import spotlightImage from '../assets/spotlight-hero.svg';

import { modalBoxStyles } from './gpg-keys-spotlight-modal.style';

export type GpgSpotlightModalProps = {
  onDismiss: () => void;
};

const GpgSpotlightModalComponent = ({
  onDismiss,
}: GpgSpotlightModalProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <ModalTransition>
      <Modal width="medium">
        <Box xcss={modalBoxStyles}>
          <img src={spotlightImage} alt={formatMessage(messages.gpgKeyIcon)} />
        </Box>
        <Box xcss={modalBoxStyles} padding="space.100">
          <ModalTitle>{formatMessage(messages.spotlightHeader)}</ModalTitle>
        </Box>
        <ModalBody>
          <Stack space="space.100">
            <Text align="center">{formatMessage(messages.spotlightBody)}</Text>
          </Stack>
        </ModalBody>
        <Box xcss={modalBoxStyles} padding="space.300">
          <ButtonGroup>
            <Button appearance="subtle" onClick={onDismiss}>
              {formatMessage(messages.spotlightDismiss)}
            </Button>
            <LinkButton
              appearance="discovery"
              href={urls.gpgKeyCreation}
              target="_blank"
              onClick={onDismiss}
            >
              {formatMessage(messages.addGpgKey)}
            </LinkButton>
          </ButtonGroup>
        </Box>
      </Modal>
    </ModalTransition>
  );
};

export const GpgSpotlightModal = React.memo(GpgSpotlightModalComponent);
